<app-status-sidebar
  [itemId]="requestId()"
  [config]="requestConfig"
  [service]="requestService"
  [updateMethod]="'updateRequest'"
  [getDetailsMethod]="'getSingleRequest'"
  [refreshTrigger]="refreshTrigger()"
></app-status-sidebar>
